import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    playerId: Number,
    url: String,
    playerName: String
  }

  open(event) {
    event.preventDefault()

    const modal = document.getElementById('comments_modal')
    if (modal) {
      // Update modal title
      const title = modal.querySelector('[data-comments-modal-title]')
      if (title) {
        title.textContent = `Comments for ${this.playerNameValue}`
      }

      // Update turbo frame src
      const frame = modal.querySelector('turbo-frame')
      if (frame) {
        frame.setAttribute('src', this.urlValue)
      }

      modal.showModal()
    }
  }
}
